var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(_vm.schema.hasHR)?_c('hr'):_vm._e(),_c('strong',{domProps:{"innerHTML":_vm._s(_vm.schema.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }